/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Payroll, PayrollFromJSON, PayrollToJSON } from './Payroll'
import { Raw, RawFromJSON, RawToJSON } from './Raw'

/**
 *
 * @export
 * @interface GetPayrollsResponse
 */
export interface GetPayrollsResponse {
  /**
   * HTTP Response Status Code
   * @type {number}
   * @memberof GetPayrollsResponse
   */
  status_code: number
  /**
   * HTTP Response Status
   * @type {string}
   * @memberof GetPayrollsResponse
   */
  status: string
  /**
   * Apideck ID of service provider
   * @type {string}
   * @memberof GetPayrollsResponse
   */
  service: string
  /**
   * Unified API resource name
   * @type {string}
   * @memberof GetPayrollsResponse
   */
  resource: string
  /**
   * Operation performed
   * @type {string}
   * @memberof GetPayrollsResponse
   */
  operation: string
  /**
   *
   * @type {Array<Payroll>}
   * @memberof GetPayrollsResponse
   */
  data: Array<Payroll>
  /**
   *
   * @type {Raw}
   * @memberof GetPayrollsResponse
   */
  _raw?: Raw | null
}

export function GetPayrollsResponseFromJSON(json: any): GetPayrollsResponse {
  return GetPayrollsResponseFromJSONTyped(json, false)
}

export function GetPayrollsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPayrollsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status_code: json['status_code'],
    status: json['status'],
    service: json['service'],
    resource: json['resource'],
    operation: json['operation'],
    data: (json['data'] as Array<any>).map(PayrollFromJSON),
    _raw: !exists(json, '_raw') ? undefined : RawFromJSON(json['_raw'])
  }
}

export function GetPayrollsResponseToJSON(value?: GetPayrollsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status_code: value.status_code,
    status: value.status,
    service: value.service,
    resource: value.resource,
    operation: value.operation,
    data: (value.data as Array<any>).map(PayrollToJSON),
    _raw: RawToJSON(value._raw)
  }
}
